import React, { useState } from 'react'
import { AiTwotoneEdit } from 'react-icons/ai'
import { date } from '../../../utils/date'
import Input from '../../ui/input/input'
import { BsArrowRepeat } from "react-icons/bs";
import usePosition from '../../../hooks/position.hook'

export const ReadyCountChangeItem = (
  {
    data,
    maxValue,
    setInitData,
    modal
  }) => {
  const { updatePrevDayReadyCount } = usePosition()
  const {getData, drawingId} = modal
  const {id, countChangeDate} = data
  const readyCount = data.readyCount.toString()
  const [editMode, setEditMode] = useState(false)
  const [value, setValue] = useState(readyCount)
  const dateFormated = date.transform(countChangeDate, false)
  const todayStr = new Date().toISOString().slice(0, 10);
  const dateStr = new Date(countChangeDate).toISOString().slice(0, 10);
  const isTodayItem = todayStr === dateStr;

  const onInput = (ev) => {
    const currentVal = ev.target.value
    setValue(currentVal)
  }

  const onEditReadyCount = async () => {
    const data = {
      id,
      readyCount: value,
      drawingId
    }
    const { subusers: updated} = await updatePrevDayReadyCount(data)
    await getData(true)
    setInitData(updated)
    setEditMode(false)
  }

  const isShowSubmitIcon = value !== readyCount && value !== '0' && !!value.length

  return (
    <div key={id} className={`text-Regular(14_16) flex items-center gap-[10px] min-h-[3rem]`}>
      <span className={`text-Regular(16_18) pl-[2rem]`}>{dateFormated}:</span>
      <span className={`font-bold text-Regular(16_18)`}>{readyCount}</span>
      {!isTodayItem && (
        <span className={`hover:cursor-pointer hover:text-Accent/Blue`} onClick={() => setEditMode(!editMode)}>
          <AiTwotoneEdit />
        </span>
      )}
      {editMode && <div className={`flex items-center gap-[2px]`}>
        <Input maxValue={maxValue + Number(readyCount)} extraSmall initial={readyCount} onInput={onInput} value={readyCount} type={'text'} placeholder={'Изменить'}/>
        {isShowSubmitIcon &&
          <span className={`text-Regular(24_30) hover:cursor-pointer hover:text-Accent/Blue`} onClick={onEditReadyCount}>
          <BsArrowRepeat />
        </span>}
      </div>
      }
    </div>
  )
}
